module.exports = __webpack_public_path__ + "static/key-myfriend-267750817a0344b7132850ec29e604a1.webp";